<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg" elevation="1">
          <v-card-title color="#f8f9fb" elevation="0">
            <v-row align="center" no-gutters>
              <v-col cols="auto">
                <span class="text-h6 font-weight-regular">{{
                  $t("complaints.title")
                }}</span>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" sm="3" md="3" class="px-2">
                <v-text-field
                  v-model="search"
                  label="Search"
                  append-icon="mdi-magnify"
                  single-line
                  hide-details
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" md="2" class="px-2">
                <v-select
                  v-model="current_status"
                  :items="filter_status"
                  item-text="name"
                  item-value="value"
                  label="Status"
                  hide-details
                  dense
                  outlined
                  clearable
                />
              </v-col>
            </v-row>
          </v-card-title>
          <v-divider></v-divider>

            <v-tabs
              color="primary"
              v-model="currentTab"
              @change="storeSelectedTabValue"
            >
              <v-tab v-for="tab in tabs" :key="tab.name" :href="'#' + tab.name">
                {{ tab.name }}
              </v-tab>
              <v-spacer></v-spacer>
            </v-tabs>
            <v-tabs-items v-model="currentTabComponent">
              <component
                v-bind:is="currentTabComponent"
                :cs="current_status"
                :parent_search="search"
              ></component>
            </v-tabs-items>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations } from "vuex";
import ActiveComplaints from "./ActiveComplaints.vue";
import ClosedComplaints from "./ClosedComplaints.vue";

export default {
  components: {
    ActiveComplaints,
    ClosedComplaints,
  },
  data() {
    return {
      loading: false,
      society_id: "",
      tabs: [
        { name: "Active Tickets", component: "ActiveComplaints" },
        { name: "Closed Tickets", component: "ClosedComplaints" },
      ],
      currentTab: "",
      search: "",
      status: [
        { name: "Pending", value: 0 },
        { name: "In Progress", value: 1 },
        { name: "Completed", value: 2 },
        { name: "Cancelled", value: 3 },
      ],
      current_status: -1,
    };
  },
  watch: {
    currentTab: function() {
      this.current_status = -1;
    },
    current_status: function() {
      [null, undefined, "null", "undefined"].includes(this.current_status) ? this.current_status = -1 : null;
    }
  },
  computed: {
    currentTabComponent: function () {
      let tab = this.tabs.find((tab) => tab.name == this.currentTab);
      return tab ? tab.component : "";
    },
    filter_status: function() {
      if(this.currentTab == "Active Tickets") {
        return this.status.filter(s => {
          return [0,1].includes(s.value);
        })
      } else {
        return this.status.filter(s => {
          return [2,3].includes(s.value);
        })
      }
    }
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    ...mapMutations("society", ["setSelectedTab"]),
    storeSelectedTabValue() {
      this.setSelectedTab({
        selectedTab: this.currentTab,
      });
    },
  },
  mounted() {
    this.user = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : {};
    if (
      ![null, undefined, ""].includes(this.$store.state.society.selectedTab)
    ) {
      this.currentTab = this.$store.state.society.selectedTab;
    }
  },
};
</script>